import React, { useState } from "react";
import { FiArchive } from "react-icons/fi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";

import StyledModal from "components/StyledModal";
import { getErrors } from "helpers/error";
import * as api from "services/api";

import {
	ButtonsContainer,
	ContractInfoCard,
	ModalHeader
} from "../ArchiveContractModal/styles";

export default function UnarchiveContractModal({
	isOpen,
	contract,
	onCancel,
	onUnarchived
}) {
	const [isLoading, setIsLoading] = useState(false);
	const { token } = useSelector(s => s.login);

	async function handleConfirm() {
		try {
			setIsLoading(true);

			const response = await api.sendPost(
				`/contracts/${contract._id}/unarchive`,
				null,
				{ Authorization: "Bearer " + token }
			);

			const result = await response.json();

			if (result.isValid) {
				toast.success(
					"Contrato desarquivado. Retornou às pendências de assinatura do contratante."
				);
				onUnarchived && onUnarchived();
			} else {
				const errors = getErrors(result.errors);
				toast.error(
					errors.default || "Não foi possível desarquivar o contrato."
				);
			}
		} catch (error) {
			toast.error("Não foi possível desarquivar o contrato. Tente novamente.");
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}

	if (!contract) return null;

	return (
		<StyledModal
			open={isOpen}
			handleClose={onCancel}
			style={{ top: "50%", width: "90%", maxWidth: "440px" }}
		>
			<ModalHeader>
				<FiArchive />
				<div>
					<h1>Desarquivar contrato?</h1>
					<p>
						O contrato voltará para a lista de pendências de assinatura do
						contratante e será notificado novamente pelos disparos de pendência.
					</p>
				</div>
			</ModalHeader>

			<ContractInfoCard>
				<strong>{contract.hired?.businessName}</strong>
				<span>
					Contrato: {contract.template?.name} · Contratante:{" "}
					{contract.mei?.businessName}
				</span>
			</ContractInfoCard>

			<ButtonsContainer>
				<button onClick={onCancel} disabled={isLoading}>
					Cancelar
				</button>
				<button onClick={handleConfirm} disabled={isLoading}>
					{isLoading ? <Spinner size="sm" /> : "Desarquivar contrato"}
				</button>
			</ButtonsContainer>
		</StyledModal>
	);
}
